import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`
});

// Add token to all requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle expired tokens
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {

      if (error.config.url.includes('/login')) {
        // Just reject and let login component handle error
        return Promise.reject(error);
      }

      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api; 